import React from 'react'
import HelpIcon from '@material-ui/icons/Help'
import Popover from '@material-ui/core/Popover'
import styled from 'styled-components'
import { svgIconStyle, colors, theme } from '../../theme/Global'

const PopoverContent = styled.div`
  width: 250px;
  font-size: 13px;
  p {
    padding: 0px 10px 0px 10px;
    color: ${theme.colors.text};
  }
  h3 {
    padding: 10px;
    background: ${colors.mediumGrey};
    margin: 0px;
    color: ${theme.colors.text};
  }
  ul {
    margin-right: 10px;
    color: ${theme.colors.text};
  }
  a {
    color: ${theme.colors.blueText};
    text-decoration: none;
  }
`

export const SupportedBrowsersHelpIcon = ({
  setAnchorEl,
  anchorEl
}) => {
  return (
    <React.Fragment>
      <HelpIcon
        style={svgIconStyle({
          color: `${colors.mediumBlue}`,
          cursor: 'pointer',
          position: 'relative',
          top: '-40px',
          left: '-350px'
        })}
        onClick={(event) => {
          setAnchorEl(event.currentTarget)
        }}
        aria-owns={anchorEl ? 'render-props-popover' : null}
      />
      <Popover
        id="render-props-popover"
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null)
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <PopoverContent>
          <h3>Supported Browsers</h3>
          <p>When using the GovDocs Dashboard, we recommend using one of the following supported browsers:</p>
          <ul>
            <li>Latest versions of Firefox, Chrome or Safari</li>
          </ul>
          <p>
            Is your browser up to date?<br />
            Visit <a className="link" href="https://www.whatismybrowser.com" target="_blank" rel="noreferrer">whatismybrowser.com</a> to find out.
          </p>
        </PopoverContent>
      </Popover>
    </React.Fragment>
  )
}
